// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

import { type ReactElement, useState, useCallback, Suspense, lazy } from 'react';
import { SUPPORTED_LANGUAGES, getFlagUrl } from '@/lib/i18n';
import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const LanguageDropdown = lazy(() => import('./LanguageDropdown'));

interface Props {
  /**
   * Görünüm: 'chrome' üst menü şeridinde (menü rengiyle uyumlu), 'sade' giriş ekranı gibi
   * nötr zeminlerde. Menü token'ları (chrome-fg/chrome-bg) login'in açık zemininde okunmuyor —
   * orada metin rengi tema token'larından gelmeli.
   */
  readonly gorunum?: 'chrome' | 'sade';
}

export function LanguageSelector({ gorunum = 'chrome' }: Props = {}): ReactElement {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const currentLang = SUPPORTED_LANGUAGES.find((l) => l.code === i18n.language);

  const toggle = useCallback(() => setOpen((p) => !p), []);
  const close = useCallback(() => setOpen(false), []);

  return (
    <div className="relative">
      <button
        type="button"
        onClick={toggle}
        className={`flex items-center gap-1.5 px-2 py-1.5 rounded-lg transition-colors ${
          gorunum === 'sade'
            ? 'text-muted-foreground hover:text-foreground hover:bg-muted'
            : 'chrome-fg-70 hover:chrome-fg hover:chrome-bg-10'
        }`}
        title={currentLang?.name ?? 'Dil Seçimi'}
      >
        {currentLang ? (
          <img
            src={getFlagUrl(currentLang.flag)}
            alt={currentLang.name}
            className="w-5 h-4 rounded-sm object-cover"
            loading="lazy"
          />
        ) : (
          <Globe className="w-5 h-5" />
        )}
        <span className="text-xs font-medium uppercase hidden sm:inline">
          {currentLang?.code ?? 'TR'}
        </span>
      </button>

      {open && (
        <Suspense
          fallback={
            <div className="absolute right-0 top-full mt-2 w-72 bg-popover rounded-xl shadow-xl border border-border z-50 p-8 text-center text-sm text-muted-foreground">
              {i18n.t('kabuk.yukleniyorNokta')}
            </div>
          }
        >
          <LanguageDropdown onClose={close} />
        </Suspense>
      )}
    </div>
  );
}
